export default __webpack_public_path__ + "static/media/claude.ec68b704.svg";